import img1 from '../../img/Infra/Infra1.png';
import img2 from '../../img/Infra/Infra2.png';
import img3 from '../../img/Infra/Infra3.png';
import img4 from '../../img/Infra/Infra4.png';
import img5 from '../../img/Infra/Infra5.png';
import img6 from '../../img/Infra/Infra6.png';
import img7 from '../../img/Infra/Infra7.png';
import img8 from '../../img/Infra/Infra8.png';
import img9 from '../../img/Infra/Infra9.png';
import img10 from '../../img/Infra/Infra10.png';
import img11 from '../../img/Infra/Infra11.png';
import img12 from '../../img/Infra/Infra12.png';
import img13 from '../../img/Infra/Infra13.png';
import img14 from '../../img/Infra/Infra14.png';


const mockProducts = [
    {
      id: 1,
      title: "Main Entrance",
      imageUrl: img1,  // Use imported image without quotes
    },
    {
      id: 2,
      title: "Performance Gallery",
      imageUrl: img2,  // Placeholder image
    },
    {
      id: 3,
      title: "Vision, Mission Banner",
      imageUrl: img3,  // Placeholder image
    },
    {
        id: 4,
        title: "Shop Floor Top View",
        imageUrl: img4,  // Use imported image without quotes
      },
      {
        id: 5,
        title: "Tool Rack Arrangement",
        imageUrl: img5,  // Placeholder image
      },
      {
        id: 6,
        title: "Tool Room Design Room",
        imageUrl: img6,  // Use imported image without quotes
      },
      {
        id: 7,
        title: "Tool Room Machine Shop",
        imageUrl: img7,  // Placeholder image
      },
      {
        id: 8,
        title: "Secondary Process Area",
        imageUrl: img8,  // Use imported image without quotes
      },
      {
        id: 9,
        title: "RM Racks",
        imageUrl: img9,  // Placeholder image
      },
    {
      id: 10,
      title: "Final Visual Inspection Area",
      imageUrl: img10,  // Placeholder image
    },
    {
      id: 11,
      title: "Domestic Packing Area",
      imageUrl: img11,  // Placeholder image
    },
    {
        id: 12,
        title: "Export Packing Area",
        imageUrl: img12,  // Placeholder image
      },
      {
        id: 13,
        title: "Press Work Station",
        imageUrl: img13,  // Placeholder image
      },
      {
        id: 14,
        title: "Quarantined Material Room",
        imageUrl: img14,  // Placeholder image
      },
];

export default mockProducts;
